/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Cta_TextInputs */

const en_about_cta_text = /** @type {(inputs: About_Cta_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start your journey`)
};

const de_about_cta_text = /** @type {(inputs: About_Cta_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt starten`)
};

const fr_about_cta_text = /** @type {(inputs: About_Cta_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer maintenant`)
};

const es_about_cta_text = /** @type {(inputs: About_Cta_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comienza tu camino`)
};

const it_about_cta_text = /** @type {(inputs: About_Cta_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia il tuo percorso`)
};

const nl_about_cta_text = /** @type {(inputs: About_Cta_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begin je reis`)
};

const pl_about_cta_text = /** @type {(inputs: About_Cta_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpocznij swoja podroz`)
};

const fi_about_cta_text = /** @type {(inputs: About_Cta_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloita matkasi`)
};

const da_about_cta_text = /** @type {(inputs: About_Cta_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start din rejse`)
};

const sv_about_cta_text = /** @type {(inputs: About_Cta_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borja din resa`)
};

/**
* | output |
* | --- |
* | "Start your journey" |
*
* @param {About_Cta_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_cta_text = /** @type {((inputs?: About_Cta_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Cta_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_cta_text(inputs)
	if (locale === "fr") return fr_about_cta_text(inputs)
	if (locale === "es") return es_about_cta_text(inputs)
	if (locale === "it") return it_about_cta_text(inputs)
	if (locale === "nl") return nl_about_cta_text(inputs)
	if (locale === "pl") return pl_about_cta_text(inputs)
	if (locale === "fi") return fi_about_cta_text(inputs)
	if (locale === "da") return da_about_cta_text(inputs)
	if (locale === "sv") return sv_about_cta_text(inputs)
	return en_about_cta_text(inputs)
});